import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { PublicHeader } from "./PublicHeader";

interface PublicShellProps {
  children: ReactNode;
  fullBleed?: boolean;
  className?: string;
  hideFooter?: boolean;
}

/**
 * Public marketing/auth shell: branded header + responsive main + minimal footer.
 */
export const PublicShell = ({
  children,
  fullBleed = false,
  className = "",
  hideFooter = false,
}: PublicShellProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-primary/5 via-secondary/5 to-accent/5">
      <PublicHeader />
      <main
        className={
          fullBleed
            ? `flex-1 w-full ${className}`
            : `flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10 ${className}`
        }
      >
        {children}
      </main>
      {!hideFooter && (
        <footer className="border-t bg-card/40 backdrop-blur">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-muted-foreground">
            <p>© {new Date().getFullYear()} KidsAI+ · Making AI learning accessible to every child.</p>
            <nav className="flex flex-wrap items-center gap-4">
              <Link to="/pricing" className="hover:text-foreground">Pricing</Link>
              <Link to="/install" className="hover:text-foreground">Install</Link>
              <Link to="/certificate/verify" className="hover:text-foreground">Verify Certificate</Link>
              <Link to="/login" className="hover:text-foreground">Login</Link>
            </nav>
          </div>
        </footer>
      )}
    </div>
  );
};

export default PublicShell;
